var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar1 = function SvgStar1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 305,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.814-60.175a8 8 0 0 1 7.727 2.07L412.287 87.642a8 8 0 0 1 2.071 7.728L361.011 294.46a8 8 0 0 1-5.657 5.657l-199.092 53.347a8.003 8.003 0 0 1-7.728-2.071L2.789 205.648a8 8 0 0 1-2.071-7.727L54.065-1.172a8 8 0 0 1 5.657-5.656l199.092-53.347Z",
    fill: "url(#Star_1_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Star_1_svg__a",
    x1: 215.242,
    y1: -61.373,
    x2: 103.767,
    y2: 354.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD343D"
  })))));
};
export default SvgStar1;